/* istanbul ignore file */
import { Show } from 'framework/show';
import { useProjectId, useProjectService } from 'domain/shared/project';
import { SensitiveShowElementLayout } from 'framework/sensitiveData';
import ViewProjectPageContent from './ViewProjectPageContent';

const ViewProject = () => {
  const id = useProjectId();
  const { getById, getName } = useProjectService();

  return (
    <Show getDataMethod={() => getById(id)}>
      <SensitiveShowElementLayout loadSensitiveDataMethod={getName} sensitiveDataId={id} sensitiveDataIdSource="id">
        <ViewProjectPageContent />
      </SensitiveShowElementLayout>
    </Show>
  );
};

export default ViewProject;
